import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	title: {
		id: 'eoc.heartbeats.confirm-modal.title.no-translate',
		defaultMessage: '{isEnabled, select, true {Turn off} other {Turn on}} auto-heartbeats',
		description: 'The text will be displayed in the confirm modal title',
	},
	turnOnDescription: {
		id: 'eoc.heartbeats.confirm-modal.turn-on-description.no-translate',
		defaultMessage:
			'We’ll automatically create a new heartbeat for each ping request you send, if the heartbeat doesn’t already exist.',
		description: 'The text will be displayed in the turn on confirm modal body description',
	},
	turnOffDescription: {
		id: 'eoc.heartbeats.confirm-modal.turn-off-description.no-translate',
		defaultMessage: 'We’ll no longer create heartbeats for the pings you send.',
		description: 'The text will be displayed in the turn off confirm modal body description',
	},
	cancel: {
		id: 'eoc.heartbeats.confirm-modal.cancel-button.no-translate',
		defaultMessage: 'Cancel',
		description: 'The text will be displayed in the confirm modal footer for cancel button.',
	},
	actionButton: {
		id: 'eoc.heartbeats.extra-property.confirm-modal.confirm-button.no-translate',
		defaultMessage: '{isEnabled, select, true {Turn off} other {Turn on}}',
		description: 'The text will be displayed in the confirm modal footer for confirm button.',
	},
});
